import api from "./api";

export interface createSettingsDto {
  companyName: string;
  companyPhoneNumber: string;
  companyFax: string;
  companyEmail: string;
  defaultMode: string;
  symbol: string;
  defaultLanguage: string;
}
export const getSettingsById = async () => {
  return await api.get(`/settings`);
};
export const editSettings = async (
  settingsId: any,
  body: createSettingsDto
) => {
  return await api.put(`/settings/${settingsId}`, body);
};

export const getCurrencyById = async () => {
  return await api.get(`/settings/main-currency`);
};
export const getSecondaryCurrencyById = async () => {
  return await api.get(`/settings/secondary-currency`);
};
// export const getSettings = async () => {
//   return await api.get(`/settings`);
// };
